<lib-cfi-file-upload 
  [configJson]="configJson"
  [allowPointerEvents]="allowPointerEvents"
  [enrollmentBuilderView]="enrollmentBuilderView"
  [isEnabled]="isEnabled"
  [showUploadProgress]="false"
  [class.pointers]="allowPointerEvents"
  (filesAdded)="onFilesAdded($event)"
  (filesChanged)="onFilesChanged($event)"
  (retryRequested)="onRetryRequested()"
  (viewRequested)="onViewRequested($event)">
</lib-cfi-file-upload>
